import(/* webpackMode: "eager" */ "/vercel/path0/app/docs/glossary/page.tsx");
